export const getDeliveryReportTenantEndpoint = (deliveryReportUid: string) =>
  `/delivery-report/tenants/${deliveryReportUid}` as const
